<div class="navigation">
    <span class="prev" (click)="prev()" *ngIf="isPrev()">
        <i class="ai ai-back arrow"></i>
    </span>
    <span class="next" (click)="next()">
        <i class="ai ai-next arrow"></i>
    </span>
</div>

